// src/modules/app-views/leads/pages/Init/actions/menuButton.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { ImportOutlined } from '@ant-design/icons';
import { showImportLeadsModal } from 'modules/app-views/leads/pages/Init/modals/ImportLeadsModal';
import { dropdownDivider, dropdownParameters } from 'layouts/Pages/PageHeader/dropdownMenus';

// *******************************************************************************
// MENU BUTTON
// *******************************************************************************
const leadsInitMenuButton = () => ({
  action: 'dropdownMenu',
  dropdownItems: [
    dropdownParameters,
    dropdownDivider,
    {
      key: 'importLeads',
      label: 'import',
      icon: <ImportOutlined />,
      onClick: ({ refresh }) => {
        showImportLeadsModal({ onSuccess: () => refresh?.() });
      },
    },
  ],
});

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default leadsInitMenuButton;
